export type * from './ABrandLayout.vue'
export { default as ABrandLayout } from './ABrandLayout.vue'
export type * from './ASplashLayout.vue'
export { default as ASplashLayout } from './ASplashLayout.vue'

export function offsetHexColor(hexColor: string, offsetPercentage: number = 250): string {
  // Ensure the hexColor is in a valid format
  if (!/^#?[\da-f]{6}$/i.test(hexColor)) {
    throw new Error('Invalid hex color format. Please use a valid 6-character hex color code.')
  }

  // Remove the leading '#' if present
  const cleanHex = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor

  // Convert the hex color to its RGB components
  const r = Number.parseInt(cleanHex.slice(0, 2), 16)
  const g = Number.parseInt(cleanHex.slice(2, 4), 16)
  const b = Number.parseInt(cleanHex.slice(4, 6), 16)

  // Calculate the brightness of the color (perceived brightness formula)
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b

  // Decide whether to lighten or darken the color based on brightness
  const lighten = brightness < 128 // Threshold: 128 (midpoint of 0–255)

  // Adjust each component
  const adjust = (color: number): number => {
    const offset = (color * offsetPercentage) / 100
    return lighten
      ? Math.min(255, Math.round(color + offset)) // Lighten the color
      : Math.max(0, Math.round(color - offset)) // Darken the color
  }

  const newR = adjust(r)
  const newG = adjust(g)
  const newB = adjust(b)

  // Convert the new RGB components back to a hex string
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const toHex = (color: number): string => color.toString(16).padStart(2, '0')
  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`
}
